<template>
  <div id="form-centro-ap">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">{{
            titleViewCenter
          }}</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS DE CENTRO -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-flex>
                    <v-select
                      v-model="tipoCentroValue"
                      :items="tipoCentroSelect"
                      item-text="nombre"
                      item-value="id"
                      label="Tipo Centro"
                      :box="tipeView != undefined"
                      :readonly="tipeView != undefined"
                      @input="$v.tipoCentroValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.tipoCentroValue.$touch() : null
                      "
                    ></v-select>
                    <v-text-field
                      v-model="codigoCentro"
                      :error-messages="codigoCentroErrors"
                      label="Cod Centro"
                      counter="20"
                      maxlength="20"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.codigoCentro.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.codigoCentro.$touch() : null
                      "
                    ></v-text-field>
                    <v-select
                      v-model="regionValue"
                      :items="regionesSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Region"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @change="comunaFiltro()"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-select>
                    <v-select
                      v-model="comunaValue"
                      :items="comunasSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Comuna"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.comunaValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.comunaValue.$touch() : null
                      "
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-sheet>
                      <v-switch
                        v-if="tipeCenter == 'Operacion'"
                        v-model="switch1"
                        color="indigo darken-3"
                        :disabled="tipeView == 'consulta'"
                        inset
                        :label="`Movil`"
                      ></v-switch>
                      <!-- : ${switch1.toString()} -->
                      <v-switch
                        v-model="switch2"
                        :disabled="tipeView == 'consulta'"
                        inset
                        :label="`Excepcional`"
                      ></v-switch>
                    </v-sheet>
                    <v-text-field
                      v-model="m2"
                      :error-messages="m2Errors"
                      label="Metros Cuadrados"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.m2.$touch()"
                      @blur="tipeView == 'crear' ? $v.m2.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="m3"
                      :error-messages="m3Errors"
                      label="Metros Cubicos"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.m3.$touch()"
                      @blur="tipeView == 'crear' ? $v.m3.$touch() : null"
                    ></v-text-field>
                    <v-select
                      v-model="estadoValue"
                      :items="estadoSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Estado"
                      :box="tipeView != undefined"
                      :readonly="tipeView != undefined"
                      @input="$v.estadoValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.estadoValue.$touch() : null
                      "
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      v-model="direccion"
                      :error-messages="direccionErrors"
                      label="Direccion"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.direccion.$touch()"
                      @blur="tipeView == 'crear' ? $v.direccion.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="aliasCentro"
                      :error-messages="aliasCentroErrors"
                      label="Alias Centro"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.aliasCentro.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.aliasCentro.$touch() : null
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS DE CENTRO -->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <!-- --------------------------------------------- -->
        <v-layout>
          <v-container grid-list-xl>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text">Encargado</v-toolbar-title>
            </v-toolbar>
            <v-layout justify-center>
              <v-flex xs12 md1></v-flex>
              <v-flex>
                <!-- INICIO DATOS DE ENCARGADO -->
                <template>
                  <div id="encargado-data">
                    <v-layout>
                      <v-flex lg12>
                        <v-card>
                          <v-form
                            ref="form"
                            v-model="validacion"
                            lazy-validation
                          >
                            <v-flex xs12 md1></v-flex>
                            <v-flex>
                              <v-text-field
                                v-model="rutEncargado"
                                label="Rut"
                                counter="10"
                                maxlength="10"
                                :error-messages="rutEncargadoErrors"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="dvRutEncargado()"
                                @focusout="checkRutEncargado"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.rutEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="nombreEncargado"
                                :error-messages="nombreEncargadoErrors"
                                label="Nombre"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.nombreEncargado.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.nombreEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="apellidoPaternoEncargado"
                                :error-messages="apellidoPaternoEncargadoErrors"
                                label="Apellido Paterno"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.apellidoPaternoEncargado.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.apellidoPaternoEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="apellidoMaternoEncargado"
                                :error-messages="apellidoMaternoEncargadoErrors"
                                label="Apellido Materno"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.apellidoMaternoEncargado.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.apellidoMaternoEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="telefonoEncargado"
                                :error-messages="telefonoEncargadoErrors"
                                label="Telefono"
                                counter="20"
                                maxlength="20"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.telefonoEncargado.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.telefonoEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="emailEncargado"
                                :error-messages="emailEncargadoErrors"
                                label="Email"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.emailEncargado.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.emailEncargado.$touch()
                                    : null
                                "
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md1></v-flex>
                          </v-form>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
                <!-- TERMINO DATOS DE ENCARGADO -->
              </v-flex>
              <v-flex xs12 md1></v-flex>
            </v-layout>
          </v-container>
          <v-container grid-list-xl>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Persona de Backup</v-toolbar-title
              >
            </v-toolbar>
            <v-layout justify-center>
              <v-flex xs12 md1></v-flex>
              <v-flex>
                <!-- INICIO DATOS DE BACKUP -->
                <template>
                  <div id="backup-data">
                    <v-layout>
                      <v-flex lg12>
                        <v-card>
                          <v-form
                            ref="form"
                            v-model="validacion"
                            lazy-validation
                          >
                            <v-flex xs12 md1></v-flex>
                            <v-flex>
                              <v-text-field
                                v-model="rutBackup"
                                label="Rut"
                                counter="10"
                                maxlength="10"
                                :error-messages="rutBackupErrors"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="dvRutBackup()"
                                @focusout="checkRutBackup"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.rutBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="nombreBackup"
                                :error-messages="nombreBackupErrors"
                                label="Nombre"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.nombreBackup.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.nombreBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="apellidoPaternoBackup"
                                :error-messages="apellidoPaternoBackupErrors"
                                label="Apellido Paterno"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.apellidoPaternoBackup.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.apellidoPaternoBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="apellidoMaternoBackup"
                                :error-messages="apellidoMaternoBackupErrors"
                                label="Apellido Materno"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.apellidoMaternoBackup.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.apellidoMaternoBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="telefonoBackup"
                                :error-messages="telefonoBackupErrors"
                                label="Telefono"
                                counter="20"
                                maxlength="20"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.telefonoBackup.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.telefonoBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                              <v-text-field
                                v-model="emailBackup"
                                :error-messages="emailBackupErrors"
                                label="Email"
                                :box="tipeView == 'consulta'"
                                :readonly="tipeView == 'consulta'"
                                @input="$v.emailBackup.$touch()"
                                @blur="
                                  tipeView == 'crear'
                                    ? $v.emailBackup.$touch()
                                    : null
                                "
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md1></v-flex>
                          </v-form>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
                <!-- TERMINO DATOS DE BACKUP -->
              </v-flex>
              <v-flex xs12 md1></v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout>
          <v-container>
            <v-flex xs12>
              <v-textarea
                v-model="observacion"
                label="Observaciones"
                :readonly="tipeView == 'consulta'"
                :box="tipeView == 'consulta'"
              ></v-textarea>
            </v-flex>
          </v-container>
        </v-layout>
        <v-container v-if="tipeView == 'consulta'">
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Documentación Asociada</v-toolbar-title
            >
          </v-toolbar>
          <v-card>
            <v-container>
              <v-layout>
                <v-flex md6>
                  <v-text-field
                    v-model="url"
                    label="Documento de confidencialidad"
                    :box="tipeView == 'consulta'"
                    :readonly="tipeView == 'consulta'"
                  ></v-text-field>
                  <v-text-field
                    v-model="videoCa"
                    label="Video"
                    :box="tipeView == 'consulta'"
                    :readonly="tipeView == 'consulta'"
                  ></v-text-field>
                  <v-text-field
                    v-if="opHidden != false"
                    v-model="fotografia"
                    label="Fotografía"
                    :box="tipeView == 'consulta'"
                    :readonly="tipeView == 'consulta'"
                  ></v-text-field>
                  <v-text-field
                    v-if="opHidden != false"
                    v-model="seguridad"
                    label="Documento Seguridad"
                    :box="tipeView == 'consulta'"
                    :readonly="tipeView == 'consulta'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-flex>
                    <v-btn
                      v-if="
                        this.url != null &&
                        this.url != '' &&
                        this.url !== undefined
                      "
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Confidencialidad"
                      @click="downloadEvidencia()"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      v-if="
                        this.videoCa != null &&
                        this.videoCa != '' &&
                        this.videoCa !== undefined
                      "
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Video"
                      @click="downloadEvidencia2()"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      v-if="
                        opHidden != false &&
                        this.fotografia != null &&
                        this.fotografia != '' &&
                        this.fotografia !== undefined
                      "
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Fotografia"
                      @click="downloadEvidencia3()"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      v-if="
                        opHidden != false &&
                        this.seguridad != null &&
                        this.seguridad != '' &&
                        this.seguridad !== undefined
                      "
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Seguridad"
                      @click="downloadEvidencia4()"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-container>
        <v-container>
          <v-card v-if="tipeView == 'crear' || tipeView == 'modifica'">
            <v-container>
              <v-layout>
                <v-flex xs6 grid-list-xl>
                  <v-toolbar-title class="indigo--text"
                    >Documento de confidencialidad</v-toolbar-title
                  >
                  <data-adjunto
                    :documentoId="id"
                    :tipeView="tipeView"
                    :tipeArchive="tipeArchive"
                  ></data-adjunto>
                </v-flex>
                <v-flex xs6 grid-list-xl>
                  <v-toolbar-title class="indigo--text"
                    >Carga Video</v-toolbar-title
                  >
                  <data-adjunto-ca
                    :documentoId="id"
                    :tipeView="tipeView"
                    :tipeArchive="tipeArchive"
                  ></data-adjunto-ca>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6 grid-list-xl>
                  <v-toolbar-title v-if="opHidden != false" class="indigo--text"
                    >Carga Fotografia</v-toolbar-title
                  >
                  <data-adjunto-co
                    v-if="opHidden != false"
                    :documentoId="id"
                    :tipeView="tipeView"
                    idAdjunto="3"
                    :tipeArchive="tipeArchive"
                  ></data-adjunto-co>
                </v-flex>
                <v-flex xs6 grid-list-xl>
                  <v-toolbar-title v-if="opHidden != false" class="indigo--text"
                    >Carga Seguridad</v-toolbar-title
                  >
                  <data-adjunto-c
                    v-if="opHidden != false"
                    :documentoId="id"
                    idAdjunto="4"
                    :tipeView="tipeView"
                    :tipeArchive="tipeArchive"
                  ></data-adjunto-c>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-container>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
            >Guardar <v-icon right dark>save</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-dialog v-model="dialogLoading" persistent max-width="390">
          <loading-descarga></loading-descarga>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import DataCentro from "@/modules/aplicacion/views/centros/CentroData.vue";
import DataPersonaEncargado from "@/modules/aplicacion/views/centros/PersonaData.vue";
import DataPersonaBackup from "@/modules/aplicacion/views/centros/PersonaData.vue";
import GridEvidencia from "@/modules/aplicacion/views/centros/GridEvidencia.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";
import DataAdjuntoCa from "@/components/AdjuntoDataCA.vue";
import DataAdjuntoCo from "@/components/AdjuntoDataCO.vue";
import DataAdjuntoC from "@/components/AdjuntoDataC.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "FormCentro-app",
  components: {
    AlertEmpty,
    DataCentro,
    DataPersonaEncargado,
    DataPersonaBackup,
    LoadingDescarga,
    GridEvidencia,
    DataAdjunto,
    DataAdjuntoCa,
    DataAdjuntoCo,
    DataAdjuntoC,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      base64Value: "",
      dialogLoading: false,
      headers2: [
        { text: "URL", align: "left", sortable: false, value: "url" },
        { text: "Video", sortable: false, value: "video" },
        { text: "Fotografia", sortable: false, value: "fotografia" },
        { text: "Seguridad", sortable: false, value: "seguridad" },
        {
          text: "Descargar documentos",
          sortable: false,
          value: "",
        },
      ],
      observacion: "",
      idAdjunto: "",
      opHidden: false,
      evidencia: [],
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      switch1: true,
      switch2: false,
      tipeArchive: "",
      base64Value: "",
      filenameValue: "",
      base64Value2: "",
      filenameValue2: "",
      base64Value3: "",
      filenameValue3: "",
      base64Value4: "",
      filenameValue4: "",
      // -----CENTRO----
      estado: [
        {
          id: 2,
          descripcion: "APROBADO",
        },
        {
          id: 3,
          descripcion: "REPROBADO",
        },
        {
          id: 4,
          descripcion: "OBSERVADO",
        },
      ],
      estadoValue: "",
      estadoSelect: [],
      tipoCentroValue: "",
      tipoCentroSelect: [],
      codigoCentro: "",
      regionValue: "",
      regionesSelect: [],
      comunaValue: "",
      comunasSelect: [],
      m2: "",
      m3: "",
      direccion: "",
      aliasCentro: "",
      // -----ENCARGADO---
      rutEncargado: "",
      nombreEncargado: "",
      fileName: "",
      filename2: "",
      url: "",
      videoCa: "",
      fotografia: "",
      seguridad: "",
      apellidoMaternoEncargado: "",
      apellidoPaternoEncargado: "",
      telefonoEncargado: "",
      emailEncargado: "",
      // -----BACKUP----
      rutBackup: "",
      nombreBackup: "",
      apellidoMaternoBackup: "",
      apellidoPaternoBackup: "",
      telefonoBackup: "",
      emailBackup: "",

      centro: "",
      idCentro: "",
      contratoId: "",
      titleViewCenter: "",
      dvEncargado: "",
      dvBackup: "",
      tipeCenter: "",
      validacion: false,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  validations: {
    codigoCentro: { required },
    m2: { required },
    m3: { required },
    direccion: { required },
    aliasCentro: { required },
    observacion: { required },
    rutEncargado: { required },
    rutBackup: { required },
    apellidoMaternoEncargado: { required },
    apellidoMaternoBackup: { required },
    apellidoPaternoEncargado: { required },
    apellidoPaternoBackup: { required },
    nombreEncargado: { required },
    nombreBackup: { required },
    emailEncargado: { required, email },
    emailBackup: { required, email },
    telefonoEncargado: { required, email },
    telefonoBackup: { required, email },
  },

  created() {
    this.tipeArchive = "*";
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.titleViewCenter = this.$route.params.titleViewCenter;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.idCentro = this.$route.params.idCentro;
      this.idContrato = this.$store.getters.contratoStored;
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadData();
      console.log(this.url);
      this.loadDataEvidenciaAlmacenada();
    }
    if (this.tipeView == "crear") {
      this.tipoCentroSelect = [this.$store.getters.subTabSelectedStored];
      this.tipoCentroValue = this.$store.getters.subTabSelectedStored;
      this.loadDataComuna();
    }
    if (this.tipeView == "modifica") {
      this.idCentro = this.$route.params.idCentro;
      this.idContrato = this.$store.getters.contratoStored;
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadDataComuna();
      this.loadData();
    }
    if (this.tipeCenter == "Operacion") {
      this.opHidden = true;
    }
    if (this.userlogged == "PROVEEDOR") {
      this.visibleNew = true;
    } else {
      this.visibleNew = false;
    }

    this.base64Value = this.$store.getters.base64Stored;
    this.filenameValue = this.$store.getters.filenameStored;
  },
  mounted() {},
  computed: {
    codigoCentroErrors() {
      const errors = [];
      if (!this.$v.codigoCentro.$dirty) return errors;
      !this.$v.codigoCentro.required &&
        errors.push("Codigo centro es obligatorio.");
      return errors;
    },
    m2Errors() {
      const errors = [];
      if (!this.$v.m2.$dirty) return errors;
      !this.$v.m2.required && errors.push("Metros cuadrados es obligatorio.");
      return errors;
    },
    m3Errors() {
      const errors = [];
      if (!this.$v.m3.$dirty) return errors;
      !this.$v.m3.required && errors.push("Metros cubicos es obligatorio.");
      return errors;
    },
    direccionErrors() {
      const errors = [];
      if (!this.$v.direccion.$dirty) return errors;
      !this.$v.direccion.required && errors.push("Direccion es obligatorio.");
      return errors;
    },
    aliasCentroErrors() {
      const errors = [];
      if (!this.$v.aliasCentro.$dirty) return errors;
      !this.$v.aliasCentro.required &&
        errors.push("Alias centro es obligatorio.");
      return errors;
    },
    rutEncargadoErrors() {
      const errors = [];
      if (!this.$v.rutEncargado.$dirty) return errors;
      !this.$v.rutEncargado.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    rutBackupErrors() {
      const errors = [];
      if (!this.$v.rutBackup.$dirty) return errors;
      !this.$v.rutBackup.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    nombreEncargadoErrors() {
      const errors = [];
      if (!this.$v.nombreEncargado.$dirty) return errors;
      !this.$v.nombreEncargado.required &&
        errors.push("Nombre es obligatorio.");
      return errors;
    },
    nombreBackupErrors() {
      const errors = [];
      if (!this.$v.nombreBackup.$dirty) return errors;
      !this.$v.nombreBackup.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoMaternoEncargadoErrors() {
      const errors = [];
      if (!this.$v.apellidoMaternoEncargado.$dirty) return errors;
      !this.$v.apellidoMaternoEncargado.required &&
        errors.push("Apellido es obligatorio.");
      return errors;
    },
    apellidoMaternoBackupErrors() {
      const errors = [];
      if (!this.$v.apellidoMaternoBackup.$dirty) return errors;
      !this.$v.apellidoMaternoBackup.required &&
        errors.push("Apellido es obligatorio.");
      return errors;
    },
    apellidoPaternoEncargadoErrors() {
      const errors = [];
      if (!this.$v.apellidoPaternoEncargado.$dirty) return errors;
      !this.$v.apellidoPaternoEncargado.required &&
        errors.push("Apellido es obligatorio.");
      return errors;
    },
    apellidoPaternoBackupErrors() {
      const errors = [];
      if (!this.$v.apellidoPaternoBackup.$dirty) return errors;
      !this.$v.apellidoPaternoBackup.required &&
        errors.push("Apellido es obligatorio.");
      return errors;
    },
    telefonoEncargadoErrors() {
      const errors = [];
      if (!this.$v.telefonoEncargado.$dirty) return errors;
      !this.$v.telefonoEncargado.required &&
        errors.push("Telefono es requerido.");
      return errors;
    },
    observacionErrors() {
      const errors = [];
      if (!this.$v.observacion.$dirty) return errors;
      !this.$v.observacion.required &&
        errors.push("Observacion es obligatorio.");
      return errors;
    },
    telefonoBackupErrors() {
      const errors = [];
      if (!this.$v.telefonoBackup.$dirty) return errors;
      !this.$v.telefonoBackup.required && errors.push("Telefono es requerido.");
      return errors;
    },
    emailEncargadoErrors() {
      const errors = [];
      if (!this.$v.emailEncargado.$dirty) return errors;
      !this.$v.emailEncargado.email && errors.push("Must be valid e-mail");
      !this.$v.emailEncargado.required && errors.push("E-mail es requerido");
      if (this.exist) {
        errors.push("E-mail ya existe");
      }
      return errors;
    },
    emailBackupErrors() {
      const errors = [];
      if (!this.$v.emailBackup.$dirty) return errors;
      !this.$v.emailBackup.email && errors.push("Must be valid e-mail");
      !this.$v.emailBackup.required && errors.push("E-mail es requerido");
      if (this.exist) {
        errors.push("E-mail ya existe");
      }
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.tipoCentroValue.$dirty) return errors;
      !this.$v.tipoCentroValue.required && errors.push("Item es requerido");
      return errors;
    },
  },
  methods: {
    async loadDataEvidenciaAlmacenada() {
      this.loading = true;
      this.evidencia = await this.loadEvidenciaAlmacenadaAll();
      this.loading = false;
      if (this.evidencia.length > 0) {
        this.$parent.alerta = false;
      } else {
        this.$parent.alerta = true;
      }
    },
    async loadEvidenciaAlmacenadaAll() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/centro/" + this.idCentro + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    downloadEvidencia() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = this.urlm;
      this.body = {
        fileName: fileName,
        idContrato: idContrato,
      };
      axios
        .post("/centro/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    downloadEvidencia2() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = this.videoCah;

      this.body = {
        fileName: fileName,
        idContrato: idContrato,
      };

      axios
        .post("/centro/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    downloadEvidencia3() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = this.fotografiah;

      this.body = {
        fileName: fileName,
        idContrato: idContrato,
      };

      axios
        .post("/centro/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    downloadEvidencia4() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = this.seguridadh;
      this.body = {
        fileName: fileName,
        idContrato: idContrato,
      };
      axios
        .post("/centro/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    getEstadoName(estadoId) {
      let encontrar = this.estado.find(function (x) {
        if (estadoId !== undefined) {
          return x.id == estadoId;
        } else {
          return x.id == estadoId;
        }
      });
      return encontrar.descripcion;
    },
    getRegionName(regionId) {
      let encontrar = this.genRegionComuna.find(function (x) {
        if (regionId.code !== undefined) {
          return x.id == regionId.code;
        } else {
          return x.id == regionId;
        }
      });
      return encontrar.nombre;
    },
    getComunaName(comunaId) {
      let encontrar = this.comunasSelect.find(function (x) {
        if (comunaId.code !== undefined) {
          return x.code == comunaId.code;
        } else {
          return x.code == comunaId;
        }
      });
      return encontrar.nombre;
    },
    dvRutEncargado() {
      let f = this.formateaRut(this.rutEncargado);
      if (f == undefined) {
        this.rutEncargado = this.rutEncargado;
      } else {
        this.rutEncargado = f;
      }
    },
    checkRutEncargado() {
      let v = this.validaRut(this.rutEncargado);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dvEncargado = obtenerDv(this.rutEncargado);
        return console.log("verdadero");
      }
    },

    dvRutBackup() {
      let f = this.formateaRut(this.rutBackup);
      if (f == undefined) {
        this.rutBackup = this.rutBackup;
      } else {
        this.rutBackup = f;
      }
    },

    checkRutBackup() {
      let v = this.validaRut(this.rutBackup);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dvBackup = obtenerDv(this.rutBackup);
        return console.log("verdadero");
      }
    },

    async loadData() {
      this.centro = await this.loadCentroData();
      // -----CENTRO----
      this.tipoCentroValue = this.centro.tipoCentro.descripcion;
      this.tipoCentroSelect = [this.tipoCentroValue];
      this.codigoCentro = this.centro.codCentro;

      this.regionValue = {
        nombre: this.centro.region.nombre,
        code: this.centro.region.id,
      };
      this.regionesSelect = [
        {
          nombre: this.centro.region.nombre,
          code: this.centro.region.id,
        },
      ];
      this.comunaValue = {
        nombre: this.centro.comuna.nombre,
        code: this.centro.comuna.id,
      };
      this.comunasSelect = [
        {
          nombre: this.centro.comuna.nombre,
          code: this.centro.comuna.id,
        },
      ];
      if (this.tipeView == "consulta") {
        this.estadoValue = {
          nombre: this.centro.estadoCentro.descripcion,
          code: this.centro.estadoCentro.id,
        };
        this.estadoSelect = [
          {
            nombre: this.centro.estadoCentro.descripcion,
            code: this.centro.estadoCentro.id,
          },
        ];
      } else {
        let estaNombre =
          this.centro.estadoCentro.descripcion !== undefined &&
          this.centro.estadoCentro.descripcion != null
            ? this.centro.estadoCentro.descripcion
            : "";
        let esta = [];
        let estaCode = [];
        this.estado.forEach(function (r) {
          esta.push({ nombre: r.descripcion, code: r.id });
          if (r.descripcion == estaNombre) {
            estaCode.push({ code: r.id });
          }
        });
        this.estadoSelect = esta;
        this.estadoValue = estaCode[0];
      }

      this.m2 = this.centro.m2;
      this.m3 = this.centro.m3;
      this.direccion = this.centro.direccion;
      this.aliasCentro = this.centro.alias;
      // -----ENCARGADO---
      this.rutEncargado =
        this.centro.rutEncargado + "-" + this.centro.dvRutEncargado;
      this.dvEncargado = this.centro.dvRutEncargado;
      this.nombreEncargado = this.centro.nombreEncargado;
      this.apellidoPaternoEncargado = this.centro.ape1Encargado;
      this.apellidoMaternoEncargado = this.centro.ape2Encargado;
      this.telefonoEncargado = this.centro.fonoEncargado;
      this.emailEncargado = this.centro.emailEncargado;
      // -----BACKUP----
      this.rutBackup =
        this.centro.rutBckEncargado + "-" + this.centro.dvRutBckEncargado;
      this.dvBackup = this.centro.dvRutBckEncargado;
      this.nombreBackup = this.centro.nombreBckEncargado;
      this.apellidoPaternoBackup = this.centro.ape1BckEncargado;
      this.apellidoMaternoBackup = this.centro.ape2BckEncargado;
      this.telefonoBackup = this.centro.fonoBckEncargado;
      this.emailBackup = this.centro.emailBckEncargado;

      let movil = 0;
      if (this.switch1 == true) {
        movil = 1;
      }
      if (this.switch2 == true) {
        excepcional = 1;
      }

      this.observacion = this.centro.observaciones;

      this.urlm = this.centro.urlAcBackupCa;
      let urlNew = this.filenameNew(this.urlm);
      this.url = urlNew;

      this.videoCah = this.centro.videoCa;
      let videoNew = this.filenameNew(this.videoCah);
      this.videoCa = videoNew;

      this.fotografiah = this.centro.fotografia;
      let fotografiaNew = this.filenameNew(this.fotografiah);
      this.fotografia = fotografiaNew;

      this.seguridadh = this.centro.seguridad;
      let seguridadNew = this.filenameNew(this.seguridadh);
      this.seguridad = seguridadNew;
    },

    async loadCentroData() {
      return await axios
        .get("/centro/" + this.idCentro + "/" + this.idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    save() {
      if (this.tipeView == "crear") {
        this.loading = true;
        this.saveCenter();
        this.loading = false;
      } else {
        this.loading = true;
        this.editCenter();
        this.loading = false;
      }
    },
    saveCenter() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      let dvE = this.obtenerDv(this.rutEncargado);
      let rutE = this.obtenerSoloRut(this.rutEncargado);
      let dvB = this.obtenerDv(this.rutBackup);
      let rutB = this.obtenerSoloRut(this.rutBackup);
      let movil = 0;
      let excepcional = 0;
      let base64EncodedStr = this.base64Value;

      if (this.centro.flMovil == 1) {
        this.switch1 == true;
      } else {
        this.switch1 == false;
      }
      if (this.centro.flExcepcional == 1) {
        this.switch2 == true;
      } else {
        this.switch2 == false;
      }

      this.body = {
        contrato: idContrato,
        tipo: this.tipoCentroValue,
        flMovil: movil,
        flExcepcional: excepcional,
        codCentro: this.codigoCentro,
        comuna: this.getComunaName(this.comunaValue),
        region: this.getRegionName(this.regionValue),
        tipoCentro: this.tipoCentroValue,
        direccion: this.direccion,
        rutEncargado: rutE,
        dvRutEncargado: dvE,
        nombreEncargado: this.nombreEncargado,
        ape1Encargado: this.apellidoPaternoEncargado,
        ape2Encargado: this.apellidoMaternoEncargado,
        fonoEncargado: this.telefonoEncargado,
        emailEncargado: this.emailEncargado,
        rutBckEncargado: rutB,
        dvRutBckEncargado: dvB,
        nombreBckEncargado: this.nombreBackup,
        ape1BckEncargado: this.apellidoPaternoBackup,
        ape2BckEncargado: this.apellidoMaternoBackup,
        fonoBckEncargado: this.telefonoBackup,
        emailBckEncargado: this.emailBackup,
        m2: this.m2,
        m3: this.m3,
        alias:
          this.aliasCentro && this.aliasCentro != null
            ? this.aliasCentro
            : null,
        // this.aliasCentro,
        observaciones: this.observacion,
        urlBackupEncargado:
          this.filenameValue && this.filenameValue != null
            ? this.filenameValue
            : null,
        docBckEncargado:
          base64EncodedStr && base64EncodedStr != null
            ? base64EncodedStr
            : null,
        video:
          this.filenameValue2 && this.filenameValue2 != null
            ? this.filenameValue2
            : null,
        docVideo:
          this.base64Value2 && this.base64Value2 != null
            ? this.base64Value2
            : null,
        fotografia:
          this.filenameValue3 && this.filenameValue3 != null
            ? this.filenameValue3
            : null,
        docFotografia:
          this.base64Value3 && this.base64Value3 != null
            ? this.base64Value3
            : null,
        seguridad:
          this.filenameValue4 && this.filenameValue4 != null
            ? this.filenameValue4
            : null,
        docSeguridad:
          this.base64Value4 && this.base64Value4 != null
            ? this.base64Value4
            : null,
      };

      axios
        .post("/centro/nuevo", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },

    editCenter() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      let dvE = this.obtenerDv(this.rutEncargado);
      let rutE = this.obtenerSoloRut(this.rutEncargado);
      let dvB = this.obtenerDv(this.rutBackup);
      let rutB = this.obtenerSoloRut(this.rutBackup);
      let movil = 0;
      let excepcional = 0;
      let base64EncodedStr = this.base64Value;

      if (this.aliasCentro === undefined) {
        this.aliasCentro = "";
      }

      if (this.switch1 == true) {
        movil = 1;
      }
      if (this.switch2 == true) {
        excepcional = 1;
      }

      if (this.regionValue == "" && this.comunaValue == "") {
        this.body = {
          estado: this.estado.value.nombre,
          contrato: idContrato,
          tipo: this.tipeCenter,
          flMovil: movil,
          flExcepcional: excepcional,
          codCentro: this.codigoCentro,
          comuna: this.getComunaName(this.comunaValue),
          region: this.getRegionName(this.regionValue),
          tipoCentro: this.tipeCenter,
          direccion: this.direccion,
          rutEncargado: rutE,
          dvRutEncargado: dvE,
          nombreEncargado: this.nombreEncargado,
          ape1Encargado: this.apellidoPaternoEncargado,
          ape2Encargado: this.apellidoMaternoEncargado,
          fonoEncargado: this.telefonoEncargado,
          emailEncargado: this.emailEncargado,
          rutBckEncargado: rutB,
          dvRutBckEncargado: dvB,
          nombreBckEncargado: this.nombreBackup,
          ape1BckEncargado: this.apellidoPaternoBackup,
          ape2BckEncargado: this.apellidoMaternoBackup,
          fonoBckEncargado: this.telefonoBackup,
          emailBckEncargado: this.emailBackup,
          observaciones: this.observacion,
          m2: this.m2,
          m3: this.m3,
          alias:
            this.aliasCentro && this.aliasCentro != null
              ? this.aliasCentro
              : null,
          urlBackupEncargado:
            this.filenameValue && this.filenameValue != null
              ? this.filenameValue
              : null,
          docBckEncargado:
            base64EncodedStr && base64EncodedStr != null
              ? base64EncodedStr
              : null,
          video:
            this.filenameValue2 && this.filenameValue2 != null
              ? this.filenameValue2
              : null,
          docVideo:
            this.base64Value2 && this.base64Value2 != null
              ? this.base64Value2
              : null,
          fotografia:
            this.filenameValue3 && this.filenameValue3 != null
              ? this.filenameValue3
              : null,
          docFotografia:
            this.base64Value3 && this.base64Value3 != null
              ? this.base64Value3
              : null,
          seguridad:
            this.filenameValue4 && this.filenameValue4 != null
              ? this.filenameValue4
              : null,
          docSeguridad:
            this.base64Value4 && this.base64Value4 != null
              ? this.base64Value4
              : null,
        };
      } else {
        this.body = {
          estado: this.getEstadoName(this.estadoValue),
          contrato: idContrato,
          tipo: this.tipeCenter,
          flMovil: movil,
          flExcepcional: excepcional,
          codCentro: this.codigoCentro,
          comuna: this.getComunaName(this.comunaValue),
          region: this.getRegionName(this.regionValue),
          tipoCentro: this.tipeCenter,
          direccion: this.direccion,
          rutEncargado: rutE,
          dvRutEncargado: dvE,
          nombreEncargado: this.nombreEncargado,
          ape1Encargado: this.apellidoPaternoEncargado,
          ape2Encargado: this.apellidoMaternoEncargado,
          fonoEncargado: this.telefonoEncargado,
          emailEncargado: this.emailEncargado,
          rutBckEncargado: rutB,
          dvRutBckEncargado: dvB,
          nombreBckEncargado: this.nombreBackup,
          ape1BckEncargado: this.apellidoPaternoBackup,
          ape2BckEncargado: this.apellidoMaternoBackup,
          fonoBckEncargado: this.telefonoBackup,
          emailBckEncargado: this.emailBackup,
          observaciones: this.observacion,
          m2: this.m2,
          m3: this.m3,
          alias:
            this.aliasCentro && this.aliasCentro != null && this.aliasCentro
              ? this.aliasCentro
              : null,
          urlBackupEncargado:
            this.filenameValue && this.filenameValue != null
              ? this.filenameValue
              : null,
          docBckEncargado:
            base64EncodedStr && base64EncodedStr != null
              ? base64EncodedStr
              : null,
          video:
            this.filenameValue2 && this.filenameValue2 != null
              ? this.filenameValue2
              : null,
          docVideo:
            this.base64Value2 && this.base64Value2 != null
              ? this.base64Value2
              : null,
          fotografia:
            this.filenameValue3 && this.filenameValue3 != null
              ? this.filenameValue3
              : null,
          docFotografia:
            this.base64Value3 && this.base64Value3 != null
              ? this.base64Value3
              : null,
          seguridad:
            this.filenameValue4 && this.filenameValue4 != null
              ? this.filenameValue4
              : null,
          docSeguridad:
            this.base64Value4 && this.base64Value4 != null
              ? this.base64Value4
              : null,
        };
      }

      axios
        .put("/centro/update/" + this.idCentro, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    async loadDetailSubitem() {
      this.detail = await this.detailSubitem();
    },
    async loadDataRecepcion() {
      this.loading = true;
      this.itemsRecepcion = await this.loadRecepcion();
      if (this.itemsRecepcion.length > 0) {
        this.alertaRecibidos = false;
      } else {
        this.alertaRecibidos = true;
      }
      this.loading = false;
    },
    async detailSubitem() {
      return await axios
        .get("recepcion/" + this.idAcuerdo + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadRecepcion() {
      return await axios
        .get("recepcion/recibidos/" + this.idSubitem + "/" + this.idContrato)
        .then(function (response) {
          console.log(response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async downloadFile(filename) {
      this.body = {
        fileName: filename,
        idContrato: this.idContrato,
      };
      return await axios
        .post("recepcion/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    newRecepcion() {
      setTimeout(() => {
        this.$router.push({
          name: "RecepcionRegistra",
          params: {
            tipeView: "crear",
            idSubitem: this.idSubitem,
            idAcuerdo: this.idAcuerdo,
          },
        });
      }, 1000);
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCapacitacion",
        });
      }, 1000);
    },
  },
};
</script>
